// --------------------------------------------------------------------------
// Custom Histogram for CPT to count events per daytime hour.
// --------------------------------------------------------------------------

import React from 'react';
import { BarChart, Bar, ResponsiveContainer, Tooltip,
  TooltipProps } from 'recharts';

interface HistogramProps {
  data: { time_start: string }[];
}

const HistogramCPT: React.FC<HistogramProps> = ({ data }) => {
  // Process data for histogram: extract hour from time_start
  const processedData = data.map(item => {
    const date = new Date(item.time_start);
    const hour = date.getUTCHours();
    return {
      hour: hour,
    };
  });

  // Convert the counts to an array for rendering and
  // count events for each hour
  const chartData = Array.from({ length: 24 }, (_, index) => {
    return {
      hour: index,
      count: processedData.filter(item => item.hour === index).length,
    };
  });

  // Custom tooltip component
  const CustomTooltip: React.FC<TooltipProps<number, string>> = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const hour = payload[0].payload.hour;
      const count = payload[0].payload.count;
      return (
        <div style={{ backgroundColor: '#242424', padding: 0, border: 'none' }}>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.625rem' }}>{`Hour: ${hour}-${hour + 1}`}</p>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.625rem' }}>{`Events: ${count}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={100}>
      <BarChart 
        data={chartData} 
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }} 
        style={{ backgroundColor: 'transparent' }}>
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="count" fill="rgba(255, 255, 255, 0.8)" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default HistogramCPT;